export enum SpacingSizeEnum {
  SmallXs = 'Small XS - 2px',
  SmallS = 'Small S - 4px',
  SmallM = 'Small M - 8px',
  SmallL = 'Small L - 12px',
  SmallXl = 'Small XL - 16px',
  MediumXs = 'Medium XS - 20px',
  MediumS = 'Medium S - 24px',
  MediumM = 'Medium M - 32px',
  MediumL = 'Medium L - 40px',
  MediumXl = 'Medium XL - 48px',
  LargeXs = 'Spacing XS - 56px',
  LargeS = 'Spacing S - 64px',
  LargeM = 'Spacing M - 80px',
  LargeL = 'Spacing L - 120px',
  LargeXl = 'Spacing XL - 160px'
}

export type SpacingSize = `${SpacingSizeEnum}`;
